import React from 'react';
import './BoothProduct.css';

export default function BoothProduct() {
  return (
    <div className="booth-product">
      <a
        className="booth-product-card"
        href="https://asmrchurch2.booth.pm/items/8769920"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/images/sermon-stained-glass-chibi-jesus.jpg"
          alt="BOOTHで「必死に止めるキリ看ちゃん」を見る（新しいタブで開きます）"
          width="887"
          height="1774"
        />
      </a>
    </div>
  );
}
